import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { JobDetailAttachment } from 'src/app/job/models/job-detail/job-detail-attachment.model';

// import Swiper core and required components
import SwiperCore, {
  Navigation,
  Pagination,
  Scrollbar,
  A11y,
  Virtual,
  Zoom,
  Autoplay,
  Thumbs,
  Controller,
} from 'swiper';
import { DomSanitizer } from '@angular/platform-browser';
// install Swiper components
SwiperCore.use([
  Navigation,
  Pagination,
  Scrollbar,
  A11y,
  Virtual,
  Zoom,
  Autoplay,
  Thumbs,
  Controller,
]);
@Component({
  selector: 'app-image-gallery',
  templateUrl: './image-gallery.component.html',
  styleUrls: ['./image-gallery.component.scss'],
})
export class ImageGalleryComponent implements OnInit {
  @Input() selectedImage: JobDetailAttachment;
  @Input() imageList: JobDetailAttachment[];
  @Input() showBeforeAfterTag = false;
  @Output() closeEvent = new EventEmitter();
  public initialSlide: number = 0;
  constructor(private sanitizer: DomSanitizer) {}
  public thumbsSwiper: any;
  panelOpenState = false;    
  public sanitizedComment: any;
  setThumbsSwiper(swiper) {
    this.thumbsSwiper = swiper;
  }
  ngOnInit(): void {
    this.initialSlide = this.imageList.findIndex(
      (i) => i.fileId == this.selectedImage.fileId
    );
    this.sanitizedComment = this.sanitizer.bypassSecurityTrustHtml(this.selectedImage.comment);
  }

  dismiss() {
    this.selectedImage.comment;
    this.closeEvent.emit();
  }
}
